// extracted by mini-css-extract-plugin
export default {"project":"ProjectList_project__-Lm-O","circle":"ProjectList_circle__1aBF1","title":"ProjectList_title__kYBfm","dark":"ProjectList_dark__GB2W2","line":"ProjectList_line__wUw3g"};